import type SessionService from '@efdigital/ll-addon-auth/services/session';
import { type Answer, type Quiz } from '@efdigital/ll-addon-data';
import { getQuizAnswerPair } from '@efdigital/ll-xceed-v2/utils/quiz/quiz-answer-pair';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../cohort';

export type QuizAnswerPair = {
  quiz: Quiz;
  answer: Answer;
};

export type CoachingCoacheeCohortQuizModel = CoachingCoacheeCohortModel & {
  chemistryQuiz?: QuizAnswerPair;
  hasPublishedAnswer: boolean;
};

export default class CoachingCoacheeCohortQuizRoute extends Route<CoachingCoacheeCohortQuizModel> {
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoacheeCohortQuizModel> {
    const parentModel = (await this.modelFor(
      'coaching.coachee.cohort'
    )) as CoachingCoacheeCohortModel;

    const quizId = parentModel.coaching.quiz?.id;
    if (!quizId) {
      return {
        ...parentModel,
        hasPublishedAnswer: false,
      };
    }

    const chemistryQuiz = await getQuizAnswerPair(
      quizId,
      this.session.cached.userId!,
      this.store
    );
    const hasPublishedAnswer =
      chemistryQuiz !== undefined &&
      !chemistryQuiz.answer.isNew &&
      !chemistryQuiz.answer.draft;

    return {
      ...parentModel,
      chemistryQuiz,
      hasPublishedAnswer,
    };
  }
}
